import React from 'react';
import {IntlProvider} from 'react-intl';
import _ from 'lodash';
import PropTypes from 'prop-types';
import YupLocaleSetter from './YupLocaleSetter';

import deTranslation from './messages.de';
import deLanguages from './languages/de.json';
import enTranslation from './messages.en';
import enLanguages from './languages/en.json';

const Context = React.createContext();
const {Provider} = Context;

class IntlProviderWrapper extends React.Component {

    static propTypes = {
        defaultLocale: PropTypes.string
    };

    static defaultProps = {
        defaultLocale: 'de'
    };

    constructor(props) {
        super(props);

        const translationUnits = {
            en: {...enTranslation, ...enLanguages},
            de: {...deTranslation, ...deLanguages}
        };

        // pass everything in state to avoid creating object inside render method (like explained in the documentation)
        this.state = {
            locale: props.defaultLocale,
            locales: _.keys(translationUnits),
            messages: translationUnits[props.defaultLocale],
            switchLanguage: (locale) => {
                this.setState({locale: locale, messages: translationUnits[locale]});
            }
        };
    }

    render() {
        const {children} = this.props;
        const {locale, messages} = this.state;
        return (
            <Provider value={this.state}>
                <IntlProvider
                    key={locale}
                    locale={locale}
                    messages={messages}
                    defaultLocale={this.props.defaultLocale}
                >
                    <>
                        <YupLocaleSetter/>
                        {children}
                    </>
                </IntlProvider>
            </Provider>
        );
    }
}

export {IntlProviderWrapper as IntlProvider, Context as IntlContext};
